import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Gallery } from "@/components/Gallery";
import { ServiceArea } from "@/components/ServiceArea";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <div className="bg-[#0c0e12] min-h-screen" data-testid="home-page">
      <div className="grain-overlay" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Gallery />
        <ServiceArea />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
